import html2canvas from "html2canvas";
export default {
  data() {
    return {
      gettingPic: [],
    };
  },
  methods: {
    capture(section, name, n) {
      this.gettingPic[n] = true;
      this.reactivity = !this.reactivity;
      setTimeout(() => {
        html2canvas(document.querySelector("#" + section))
          .then((canvas) => {
            var button = document.getElementById("download");
            button.setAttribute("href", canvas.toDataURL("image/png", 1));
            button.setAttribute("download", name);
          })
          .then(() => {
            var button = document.getElementById("download");
            button.click();
            this.gettingPic[n] = false;
            this.reactivity = !this.reactivity;
          });
      }, 500);
    },
  },
};
